<template>
  <el-button style="margin: 2.5px 4px 3.5px 0px;" size="mini" v-if="activeTab == 'event-status' || activeTab == 'event-hist' || activeTab == 'eventHist' || activeTab == 'eventStatus'" :disabled="smartAnalyzerDisableFlag" type="primary" @click="openSmartAnalyzerPopup">Smart Analyzer</el-button>
</template>

<script>
import map from 'lodash/map';
import { mapGetters } from 'vuex';
import { openEventSmartAnalyzerPopup } from '@/utils/event';

export default {
  name: 'WSmartAnalyzerButton',
  props: {
    activeTab: String,
  },
  computed: {
    smartAnalyzerDisableFlag() {
      return this.selectedEvents.length <= 0;
    },
    ...mapGetters(['selectedEvents']),
  },
  data() {
    return {
      eventData: null,
    };
  },
  beforeDestroy() {
    this.$store.dispatch('setSelectedEvents', []);
  },
  methods: {
    openSmartAnalyzerPopup() {
      let eventHistSeqNumbers;
      if (this.activeTab === 'event-status') {
        eventHistSeqNumbers = map(this.selectedEvents, 'eventSeqNumber');
      } else {
        eventHistSeqNumbers = map(this.selectedEvents, 'seqNumber');
      }
      openEventSmartAnalyzerPopup(eventHistSeqNumbers);
    },
  },
};
</script>

<style lang="scss" scoped>
.el-button--mini {
  line-height: 15px;
  margin-top: 3px;
}
</style>



// WEBPACK FOOTER //
// src/views/event/components/SmartAnalyzerButton.vue